module.exports = __webpack_public_path__ + "static/NetLogo-4ee488fc0c5c07fad84cf1c24e44556d.png";